import {Navigate, Outlet} from "react-router";

function ProtectedRoute() {
    return localStorage.getItem("go-ticket") ? <Outlet/> : <Navigate to="/login" replace/>;
}

export default ProtectedRoute;